import { buildMockAuthorizationSubject, resolveMockAuthProfile } from '@nwm-oss/auth-core';
import type { FrontendAuthSession } from './session.js';
import type { WorkspaceRuntimeMode } from './runtime.js';

export interface MockFrontendAuthSessionOptions {
  readonly profileCode: string;
  readonly runtime: WorkspaceRuntimeMode;
}

export function resolveFrontendDevProfile(options: {
  readonly search: string;
  readonly envProfile?: string;
  readonly defaultProfileCode: string;
  readonly storageKey?: string;
}): string {
  const queryProfile = new URLSearchParams(options.search).get('devProfile');
  if (queryProfile) {
    if (options.storageKey && typeof window !== 'undefined') {
      window.localStorage.setItem(options.storageKey, queryProfile);
    }
    return resolveMockAuthProfile(queryProfile).code;
  }

  if (options.storageKey && typeof window !== 'undefined') {
    const persistedProfile = window.localStorage.getItem(options.storageKey);
    if (persistedProfile) {
      return resolveMockAuthProfile(persistedProfile).code;
    }
  }

  if (options.envProfile) {
    return resolveMockAuthProfile(options.envProfile).code;
  }

  return resolveMockAuthProfile(options.defaultProfileCode).code;
}

export function createMockFrontendAuthSession(
  options: MockFrontendAuthSessionOptions,
): FrontendAuthSession {
  const identity = buildMockAuthorizationSubject(options.profileCode);

  return {
    mode: options.runtime === 'embedded' ? 'embedded' : 'mock',
    runtime: options.runtime,
    identity: {
      subjectId: identity.subjectId,
      displayName: identity.displayName,
      email: identity.email,
      username: identity.username,
      organizationId: identity.organizationId,
      activeOrgId: identity.organizationId,
      roles: identity.roles,
      permissions: identity.permissions,
      profileCode: identity.profileCode,
    },
    isAuthenticated: true,
    isLoading: false,
    error: null,
    accessToken: options.profileCode,
  };
}
